export default __webpack_public_path__ + "static/media/linkWhite.13e0ee9f.svg";